<template>
  <div>
    <div
      v-if="isInactiveLink" class="lms-access"
    >
      <span class="user-avatar" :style="{ backgroundImage: `url('${$config.imagesUrl}/avatars/thumb@128_${info.userImage || 'default-avatar.png'}')` }" />
    </div>
    <nuxt-link
      v-else-if="isLocalLink" class="lms-access"
      :to="userLink"
    >
      <span class="user-avatar" :style="{ backgroundImage: `url('${$config.imagesUrl}/avatars/thumb@128_${info.userImage || 'default-avatar.png'}')` }" />
    </nuxt-link>
    <a
      v-else class="lms-access"
      :href="`${projectLink}${userLink}`"
    >
      <span class="user-avatar" :style="{ backgroundImage: `url('${$config.imagesUrl}/avatars/thumb@128_${info.userImage || 'default-avatar.png'}')` }" />
    </a>
  </div>
</template>

<script>
import qaHubMixin from '../mixins/qa-hub.js';

export default {
  mixins: [qaHubMixin],
  props: {
    info: { type: Object, required: true },
  },
};
</script>

<style lang="scss">
  .user-avatar {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    margin-right: 12px;
    display: inline-block;
    background-position: center;
    background-size: cover;
    image-rendering: -webkit-optimize-contrast;
  }
</style>
